var map = {
	"./flag-AR.svg": 60270,
	"./flag-BO.svg": 88337,
	"./flag-BR.svg": 43671,
	"./flag-CA.svg": 23926,
	"./flag-CL.svg": 70351,
	"./flag-CO.svg": 97381,
	"./flag-DE.svg": 14859,
	"./flag-EC.svg": 43783,
	"./flag-ES.svg": 35906,
	"./flag-FR.svg": 50816,
	"./flag-GB.svg": 60404,
	"./flag-IE.svg": 82644,
	"./flag-IT.svg": 24926,
	"./flag-MX.svg": 97071,
	"./flag-PE.svg": 29435,
	"./flag-PT.svg": 64282,
	"./flag-PY.svg": 3935,
	"./flag-US.svg": 86062,
	"./flag-UY.svg": 48726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90985;